import { BaseComponent2 } from '../../_common/client/base-component2';
import { mapUrlParameterToReviewSource } from './helper/map-url-parameter-to-review-source';
import { ReviewSource, SourceToOpenSubmitLayerUrlParameter } from './types';

export type ReviewSubmissionUrlParameters = {
    sourceToOpenSubmitLayer?: SourceToOpenSubmitLayerUrlParameter;
    openLayer?: string;
};

export class CustomerReviewSubmissionRedirectorComponent extends BaseComponent2 {
    public rootSelector = '.js_pdp_cr_submission-redirector';

    public async onFirstPageLoadOncePerComponentType(): Promise<void> {
        this.automaticallyOpenReviewSubmissionSheetIfUrlParameterIsSet();
    }

    public async init(): Promise<void> {
        if (!this.isPresent()) return;
    }

    private automaticallyOpenReviewSubmissionSheetIfUrlParameterIsSet() {
        const urlParameters = o_util.fragment.deserialize<ReviewSubmissionUrlParameters>(false);
        if (urlParameters.openLayer !== 'true') return;

        const reviewSubmissionElement = document.querySelector<HTMLElement>(this.rootSelector);
        if (!reviewSubmissionElement) return;

        const { productId, variationId } = this.extractProductIdAndVariationIdFromButton(reviewSubmissionElement);
        if (productId === null || variationId === null) return;

        const reviewSource: ReviewSource | undefined = urlParameters.sourceToOpenSubmitLayer
            ? mapUrlParameterToReviewSource(urlParameters.sourceToOpenSubmitLayer)
            : undefined;
        this.redirectUserToSubmissionPage(productId, variationId, reviewSource);
    }

    private redirectUserToSubmissionPage(productId: string, variationId: string, reviewSource: ReviewSource | undefined) {
        location.assign(
            `/kundenbewertung-abgabe?productId=${productId}&variationId=${variationId}${
                reviewSource ? `&reviewSource=${reviewSource}` : ''
            }`
        );
    }

    private extractProductIdAndVariationIdFromButton(reviewSubmissionElement: HTMLElement): {
        productId: string | null;
        variationId: string | null;
    } {
        const productId = reviewSubmissionElement.getAttribute('data-product-id');
        const variationId = reviewSubmissionElement.getAttribute('data-variation-id');
        return { productId, variationId };
    }
}
